import { useTranslation } from "react-i18next";
import AssetsBar from "../../components/assets/AssetsBar";
import PageHeader from "../../components/shared/PageHeader"
import MainContent from "../../containers/shared/MainContent";
import PageMain from "../../containers/shared/PageMain"
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import apiClient from "../../components/utils/apiClient";
import { useEffect, useState } from "react";
import AssetsTable from "../../components/assets/AssetsTable";
import Pagination from "../../components/shared/Pagination";
import Loading from "../../components/shared/Loading";

const AssetsHomePage = () => {


    const {t,i18n} = useTranslation();
    useDocumentTitle('الأصول');
    const navigate = useNavigate();
    const pageTitle = {title: 'الأصول', subTitle: 'يمكنك إضافة وادارة الأصول المسجل لديك.'};
    const [assets,setAssets] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const [pageSize, setPageSize] = useState(20);
    const [currentPage,setCurrentPage] = useState(1);
    const [total,setTotal] = useState(0);
    const [currentCount,setCurrentCount] = useState(0);
    const [hasMore,setHasMore] = useState(true);
    
    const [isEmpty, setIsEmpty] = useState(true);

    const [searchParams] = useSearchParams();
    const querySearch = searchParams.get('search') || "";

    useEffect(() => {
      if (querySearch.length > 0 && querySearch.length < 3) {
        return;
      }

      const delayDebounceFn = setTimeout(() => {
        getAssets(1, querySearch);
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }, [querySearch]);

    const getAssets = async (page=1, searchTerm = "") => {

      let url = `/b-assets?skip=${(page-1)*pageSize}&limit=${pageSize}`;
      
      if (searchTerm && searchTerm.length >= 3) {
        url += `&brand=${encodeURIComponent(searchTerm)}`;
      }

      try {
        const response = await apiClient.get(url);
        if(response?.data) {
          setIsLoading(false);
          setAssets(response?.data);
          if(response?.data?.length > 0) {
            setIsEmpty(false);
            setCurrentCount(response?.data?.length);
            setCurrentPage(page);
          if(response?.data?.length === pageSize) {
                    setHasMore(true);
                }
            } else {
                setHasMore(false);
            }
        }
      } catch(err) {}
    }

    const handleChangePageAction = (page) => {
      getAssets(page);
    }
    
    useEffect(()=>{
      getAssets();
    },[]);



    return (
        <div>
            <PageHeader pageTitle={pageTitle} />
                  <PageMain>
                    <div className="fixed top-0 left-0 w-full h-full bg-grey-50 z-[-1]"></div>
                    <MainContent>
                        <AssetsBar assetsCount={assets?.length} />
                        {/* no assets view */}
                        {assets !== null && Array.isArray(assets) && assets?.length < 1 && !querySearch && !isEmpty && <Loading showLoading={true} />}
                        {assets !== null && Array.isArray(assets) && assets?.length < 1 && !querySearch && isEmpty &&
                            <div className="pt-[80px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/box.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم يتم إضافة أي أصل حتى الآن</div>
                            <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/assets/add">أضف أصل جديد</Link>
                            </div>
                        }
                        {assets !== null && Array.isArray(assets) && assets?.length < 1 && querySearch &&
                          <div className="pt-[80px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/box.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لايوجد أصول مطابقة لكلمة البحث</div>
                            {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/users/add">أضف مستخدم جديد</Link> */}
                          </div>
                        }
                        {/* assets view */}
                        {assets !== null && Array.isArray(assets) && assets?.length > 0 && 
                            <div className="pt-[25px]">
                                <AssetsTable assets={assets} currentPage={currentPage} pageSize={pageSize} />
                                <Pagination label={'أصل'} currentCount={currentCount} currentPage={currentPage} pageSize={pageSize} handleClickChangePage={page => handleChangePageAction(page)} hasMore={hasMore} />
                            </div>
                        }
                    </MainContent>
                  </PageMain>
                  {isLoading && <Loading showLoading={true} />}
        </div>
    )

}

export default AssetsHomePage;
